export const toggle = (element, visible) => {
  element.classList.toggle('d-none', !visible)
}

export const theme = () => {
  return document.documentElement.dataset.bsTheme
}

export const escapeHTML = (value) => {
  const node = document.createElement('div')
  node.innerText = value
  return node.innerHTML
}

export const textToHTML = (text) => escapeHTML(text).replace('\n', '<br/>')

export const isMobile = () => window.matchMedia('(max-width: 768px)').matches

export const controller = (element, controllerName) =>
  window.Stimulus.getControllerForElementAndIdentifier(element, controllerName)
